// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WorkflowAutoCreationDayFilter, WorkflowAutoCreationLeadUnit, WorkflowAutoCreationRule, WorkflowPlanAutomation } from "./workflow_auto_creation_rule_model_pb";
import { file_bffuser_v1_workflow_auto_creation_rule_model } from "./workflow_auto_creation_rule_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_auto_creation_rule_service.proto.
 */
export const file_bffuser_v1_workflow_auto_creation_rule_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_workflow_auto_creation_rule_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_timeofday]);

/**
 * @generated from message bffuser.v1.ListWorkflowAutoCreationRulesRequest
 */
export type ListWorkflowAutoCreationRulesRequest = Message<"bffuser.v1.ListWorkflowAutoCreationRulesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWorkflowAutoCreationRulesRequest.
 * Use `create(ListWorkflowAutoCreationRulesRequestSchema)` to create a new message.
 */
export const ListWorkflowAutoCreationRulesRequestSchema: GenMessage<ListWorkflowAutoCreationRulesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 0);

/**
 * @generated from message bffuser.v1.ListWorkflowAutoCreationRulesResponse
 */
export type ListWorkflowAutoCreationRulesResponse = Message<"bffuser.v1.ListWorkflowAutoCreationRulesResponse"> & {
  /**
   * Empty when feature_enabled is false.
   *
   * @generated from field: repeated bffuser.v1.WorkflowAutoCreationRule rules = 1;
   */
  rules: WorkflowAutoCreationRule[];

  /**
   * Evaluated value of the workflow-auto-creation-rule feature flag (false
   * on evaluation failure).
   *
   * @generated from field: bool feature_enabled = 2;
   */
  featureEnabled: boolean;

  /**
   * IDs of the visible templates with an approval-required 需要調達計画 /
   * 発電販売計画 sub-step: only 雛形どおり can be chosen for them.
   *
   * @generated from field: repeated string plan_automation_locked_template_ids = 3;
   */
  planAutomationLockedTemplateIds: string[];

  /**
   * IDs of the rules whose stored 計画の自動化 is not used because their
   * template is locked.
   *
   * @generated from field: repeated string plan_automation_unused_rule_ids = 4;
   */
  planAutomationUnusedRuleIds: string[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowAutoCreationRulesResponse.
 * Use `create(ListWorkflowAutoCreationRulesResponseSchema)` to create a new message.
 */
export const ListWorkflowAutoCreationRulesResponseSchema: GenMessage<ListWorkflowAutoCreationRulesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 1);

/**
 * WorkflowAutoCreationScheduleTriggerInput is the 定期 payload of a write
 * request.
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationScheduleTriggerInput
 */
export type WorkflowAutoCreationScheduleTriggerInput = Message<"bffuser.v1.WorkflowAutoCreationScheduleTriggerInput"> & {
  /**
   * @generated from field: int32 lead_value = 1;
   */
  leadValue: number;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationLeadUnit lead_unit = 2;
   */
  leadUnit: WorkflowAutoCreationLeadUnit;

  /**
   * @generated from field: google.type.TimeOfDay fire_time = 3;
   */
  fireTime?: TimeOfDay;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationDayFilter day_filter = 4;
   */
  dayFilter: WorkflowAutoCreationDayFilter;

  /**
   * 計画の自動化. Absent: Create stores 雛形どおり, Update keeps the stored value.
   *
   * @generated from field: optional bffuser.v1.WorkflowPlanAutomation plan_automation = 5;
   */
  planAutomation?: WorkflowPlanAutomation;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationScheduleTriggerInput.
 * Use `create(WorkflowAutoCreationScheduleTriggerInputSchema)` to create a new message.
 */
export const WorkflowAutoCreationScheduleTriggerInputSchema: GenMessage<WorkflowAutoCreationScheduleTriggerInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 2);

/**
 * @generated from message bffuser.v1.CreateWorkflowAutoCreationRulesRequest
 */
export type CreateWorkflowAutoCreationRulesRequest = Message<"bffuser.v1.CreateWorkflowAutoCreationRulesRequest"> & {
  /**
   * @generated from field: string workflow_template_id = 2;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from oneof bffuser.v1.CreateWorkflowAutoCreationRulesRequest.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTriggerInput schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTriggerInput;
    case: "schedule";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.CreateWorkflowAutoCreationRulesRequest.
 * Use `create(CreateWorkflowAutoCreationRulesRequestSchema)` to create a new message.
 */
export const CreateWorkflowAutoCreationRulesRequestSchema: GenMessage<CreateWorkflowAutoCreationRulesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 3);

/**
 * @generated from message bffuser.v1.CreateWorkflowAutoCreationRulesResponse
 */
export type CreateWorkflowAutoCreationRulesResponse = Message<"bffuser.v1.CreateWorkflowAutoCreationRulesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.WorkflowAutoCreationRule rules = 1;
   */
  rules: WorkflowAutoCreationRule[];

  /**
   * Requested areas that were not created because a scheduled rule for the
   * same template and lead already exists.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode skipped_area_codes = 2;
   */
  skippedAreaCodes: AreaCode[];
};

/**
 * Describes the message bffuser.v1.CreateWorkflowAutoCreationRulesResponse.
 * Use `create(CreateWorkflowAutoCreationRulesResponseSchema)` to create a new message.
 */
export const CreateWorkflowAutoCreationRulesResponseSchema: GenMessage<CreateWorkflowAutoCreationRulesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 4);

/**
 * @generated from message bffuser.v1.UpdateWorkflowAutoCreationRuleRequest
 */
export type UpdateWorkflowAutoCreationRuleRequest = Message<"bffuser.v1.UpdateWorkflowAutoCreationRuleRequest"> & {
  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string workflow_template_id = 3;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from oneof bffuser.v1.UpdateWorkflowAutoCreationRuleRequest.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTriggerInput schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTriggerInput;
    case: "schedule";
  } | { case: undefined; value?: undefined };

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the rule.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 20;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowAutoCreationRuleRequest.
 * Use `create(UpdateWorkflowAutoCreationRuleRequestSchema)` to create a new message.
 */
export const UpdateWorkflowAutoCreationRuleRequestSchema: GenMessage<UpdateWorkflowAutoCreationRuleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 5);

/**
 * @generated from message bffuser.v1.UpdateWorkflowAutoCreationRuleResponse
 */
export type UpdateWorkflowAutoCreationRuleResponse = Message<"bffuser.v1.UpdateWorkflowAutoCreationRuleResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationRule rule = 1;
   */
  rule?: WorkflowAutoCreationRule;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowAutoCreationRuleResponse.
 * Use `create(UpdateWorkflowAutoCreationRuleResponseSchema)` to create a new message.
 */
export const UpdateWorkflowAutoCreationRuleResponseSchema: GenMessage<UpdateWorkflowAutoCreationRuleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 6);

/**
 * @generated from message bffuser.v1.DeleteWorkflowAutoCreationRuleRequest
 */
export type DeleteWorkflowAutoCreationRuleRequest = Message<"bffuser.v1.DeleteWorkflowAutoCreationRuleRequest"> & {
  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the rule.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowAutoCreationRuleRequest.
 * Use `create(DeleteWorkflowAutoCreationRuleRequestSchema)` to create a new message.
 */
export const DeleteWorkflowAutoCreationRuleRequestSchema: GenMessage<DeleteWorkflowAutoCreationRuleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 7);

/**
 * DeleteWorkflowAutoCreationRuleResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteWorkflowAutoCreationRuleResponse
 */
export type DeleteWorkflowAutoCreationRuleResponse = Message<"bffuser.v1.DeleteWorkflowAutoCreationRuleResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowAutoCreationRuleResponse.
 * Use `create(DeleteWorkflowAutoCreationRuleResponseSchema)` to create a new message.
 */
export const DeleteWorkflowAutoCreationRuleResponseSchema: GenMessage<DeleteWorkflowAutoCreationRuleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 8);

/**
 * WorkflowAutoCreationRuleService manages 自動起票ルール (spec
 * docs/specs/workflow/workflow-templates.md §4) for the admin template page.
 * organization_id and the acting member are resolved by the BFF handler from
 * eauth.
 * The service is released by the global workflow-auto-creation-rule feature
 * flag: while it is off, List returns feature_enabled=false with no rules
 * and every write returns FAILED_PRECONDITION.
 *
 * @generated from service bffuser.v1.WorkflowAutoCreationRuleService
 */
export const WorkflowAutoCreationRuleService: GenService<{
  /**
   * ListWorkflowAutoCreationRules returns the active rules of the
   * organization, ordered by created_at then id. Rules whose template is
   * deleted or cannot be resolved are not returned.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.ListWorkflowAutoCreationRules
   */
  listWorkflowAutoCreationRules: {
    methodKind: "unary";
    input: typeof ListWorkflowAutoCreationRulesRequestSchema;
    output: typeof ListWorkflowAutoCreationRulesResponseSchema;
  },
  /**
   * CreateWorkflowAutoCreationRules creates one rule per requested area,
   * skipping areas that already have a scheduled rule (enabled or not) with
   * the same template and the same schedule.lead_*. The lead is accepted only
   * as 0 to 30 days (INVALID_ARGUMENT otherwise, including month / year
   * units). Returns ALREADY_EXISTS when every requested area is skipped, and
   * FAILED_PRECONDITION when the template does not exist in the organization
   * or cannot have a scheduled rule.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.CreateWorkflowAutoCreationRules
   */
  createWorkflowAutoCreationRules: {
    methodKind: "unary";
    input: typeof CreateWorkflowAutoCreationRulesRequestSchema;
    output: typeof CreateWorkflowAutoCreationRulesResponseSchema;
  },
  /**
   * UpdateWorkflowAutoCreationRule changes enabled, fire_time and day_filter
   * of a rule; the id never changes. workflow_template_id, area_code and
   * schedule.lead_* identify the rule and must equal its current values,
   * otherwise INVALID_ARGUMENT and nothing is saved. FAILED_PRECONDITION (flag
   * off) and INVALID_ARGUMENT (malformed input) are returned regardless of the
   * rule's state; after that the order is NOT_FOUND for a missing rule,
   * INVALID_ARGUMENT for a changed template / area / lead, FAILED_PRECONDITION
   * when the rule's current template is no longer eligible, and ABORTED when
   * expected_updated_at does not match.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.UpdateWorkflowAutoCreationRule
   */
  updateWorkflowAutoCreationRule: {
    methodKind: "unary";
    input: typeof UpdateWorkflowAutoCreationRuleRequestSchema;
    output: typeof UpdateWorkflowAutoCreationRuleResponseSchema;
  },
  /**
   * DeleteWorkflowAutoCreationRule logically deletes a rule. Returns NOT_FOUND
   * for a missing rule and ABORTED when expected_updated_at does not match.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.DeleteWorkflowAutoCreationRule
   */
  deleteWorkflowAutoCreationRule: {
    methodKind: "unary";
    input: typeof DeleteWorkflowAutoCreationRuleRequestSchema;
    output: typeof DeleteWorkflowAutoCreationRuleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 0);

